import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { checkPasswordRules } from '../../utils/passwordPolicy';

// Live checklist of the password rules; green ticks as the user types.
const PasswordRules = ({ password }) => (
    <Box sx={{ mt: 1, mb: 1 }}>
        {checkPasswordRules(password).map((rule) => (
            <Box key={rule.key} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                {rule.passed
                    ? <CheckCircleIcon sx={{ fontSize: 16, color: '#17ae7b' }} />
                    : <RadioButtonUncheckedIcon sx={{ fontSize: 16, color: '#b4bcc4' }} />}
                <Typography variant="caption" sx={{ color: rule.passed ? '#17ae7b' : '#707070' }}>
                    {rule.label}
                </Typography>
            </Box>
        ))}
    </Box>
);

export default PasswordRules;
